// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullChampionship,
} from 'common.data';

// Global Components
import * as React from 'react';

// Components
import ChampionshipsListItem from '../ChampionshipsListItem';

// Types
type $Props = $Translate & {
  basePath: string;
  data: Array<$FullChampionship>;
};

function ChampionshipsListView({
  basePath,
  data,
}: $Props) {
  return (
    <div className={'ChampionshipsList -mb-2'}>
      {data.map((dataItem: $FullChampionship) => (
        <ChampionshipsListItem
          basePath={basePath}
          item={dataItem}
          key={dataItem.id}
        />
      ))}
    </div>
  );
}

export default ChampionshipsListView;
